<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div v-if="isTarget && !isDisabled && isCancelClick">
      <div class="card">
        <div class="grid line-text mt-2">
          <div class="col-12 lg:col-6">
            <h5>{{ staticData.target.alldatacri }}</h5>
            <span>{{ staticData.target.segment }}</span>
          </div>
          <div class="col-12 lg:col-6"></div>
        </div>

        <div class="grid col-12 line-text mt-2">
          <div>
            <PrimeButton
              label="All"
              class="all-btn"
              @click="lineColor = '#5da386'"
              :class="{ 'active-btn': lineColor === '#5da386' }"
              :style="{
                backgroundColor:
                  lineColor === '#5da386' ? '#5da386' : '#f0f0ef',
              }"
            ></PrimeButton>
            <PrimeButton
              label="Any"
              class="any-btn"
              @click="lineColor = '#00c2c8'"
              :class="{ 'active-btn': lineColor === '#00c2c8' }"
              :style="{
                backgroundColor:
                  lineColor === '#00c2c8' ? '#00c2c8' : '#f0f0ef',
              }"
            ></PrimeButton>
            <PrimeButton
              label="None"
              class="none-btn"
              @click="lineColor = '#e85b46'"
              :class="{ 'active-btn': lineColor === '#e85b46' }"
              :style="{
                backgroundColor:
                  lineColor === '#e85b46' ? '#e85b46' : '#f0f0ef',
              }"
            ></PrimeButton>
            <span>{{ staticData.target.following }}</span>
            <PrimeButton
              label="Clear all criteria"
              icon="pi pi-eraser"
              class="clearCriteria"
              @click="clearAllCriteria()"
              style="margin-left: 309px"
              :class="{
                disabled: !addButtonsEnabled || triggerDropdown.length < 1,
                enabled: triggerDropdown.length >= 1,
              }"
              :disabled="!addButtonsEnabled || triggerDropdown.length < 1"
            ></PrimeButton>
            <PrimeButton
              label="Sort"
              icon="fa fa-bars"
              class="clearCriteria ml-2"
              @click="clear()"
              :class="{
                disabled: !addButtonsEnabled || triggerDropdown.length < 1,
                enabled: triggerDropdown.length >= 1,
              }"
              :disabled="!addButtonsEnabled || triggerDropdown.length < 1"
            ></PrimeButton>
          </div>
        </div>
        <div
          v-for="(criteria, index) in vmodel1.triggerDropdown"
          :key="index"
          class="grid criteria-container"
        >
          <div
            :class="{
              'vertical-line': index === vmodel1.triggerDropdown.length - 1,
              'vertical-line-full': index < vmodel1.triggerDropdown.length - 1,
            }"
            :style="{ borderColor: lineColor }"
          ></div>
          <div
            class="horizontal-line"
            :style="{ backgroundColor: lineColor }"
          ></div>

          <div
            class="col-12 lg:col-11 area-1 mt-3"
            v-if="!criteria.showMessage"
          >
            <DropDownRequire
              v-model="criteria.key"
              :options="externalDropdownVal"
              placeholder="Select a Value"
              id="SiteId12"
              optionLabel="description"
              optionValue="value"
              class="dropdown"
              editable
            />

            <DropDownRequire
              v-if="
                criteria.key !== null &&
                typeof criteria.key === 'number' &&
                (criteria.key == 0 ||
                  criteria.key == 7 ||
                  criteria.key == 2 ||
                  criteria.key == 3 ||
                  criteria.key == 4 ||
                  criteria.key == 6)
              "
              v-model="criteria.value"
              :options="internalDropdownVal"
              placeholder="Select a Value"
              id="SiteId123"
              optionLabel="description"
              class="dropdown"
              optionValue="value"
              editable
            />

            <DropDownRequire
              v-if="
                criteria.key !== null &&
                typeof criteria.key === 'number' &&
                criteria.key == 1
              "
              v-model="criteria.value"
              :options="excatMatchDropdownVal"
              placeholder="Select a Value"
              id="SiteId123"
              optionLabel="description"
              class="dropdown"
              optionValue="value"
              editable
            />

            <DropDownRequire
              v-if="
                criteria.key !== null &&
                typeof criteria.key === 'number' &&
                criteria.key == 8
              "
              v-model="criteria.value"
              :options="userDropDownVal"
              placeholder="Select a Value"
              id="SiteId123"
              optionLabel="description"
              class="dropdown"
              optionValue="value"
              editable
            />

            <DropDownRequire
              v-if="
                criteria.key !== null &&
                typeof criteria.key === 'number' &&
                criteria.key == 5
              "
              v-model="criteria.value"
              :options="providedDropDownVal"
              placeholder="Select a Value"
              id="SiteId123"
              optionLabel="description"
              class="dropdown"
              optionValue="value"
              editable
            />

            <div
              style="display: flex; height: 40px"
              v-if="
                criteria.key !== null &&
                typeof criteria.key === 'number' &&
                [2, 3, 4].includes(criteria.key)
              "
            >
              <InputRequiredText
                v-model="criteria.text1"
                PropName="Key"
                :placeholder="'Enter key'"
                id="text1"
              ></InputRequiredText>
            </div>
            <div
              class="ml-2"
              style="display: flex"
              v-if="
                criteria.key !== null &&
                typeof criteria.key === 'number' &&
                [0, 1, 6, 7].includes(criteria.key)
              "
            >
              <Chips
                v-model="vmodel1.text1"
                separator=","
                id="showPagesPathContain"
                class="chipheight w-full"
                PropName="Part of URL"
                aria-describedby="password-help"
              />
            </div>
            <div
              class="ml-2"
              style="display: flex; height: 40px"
              v-if="
                criteria.key !== null &&
                typeof criteria.key === 'number' &&
                [2, 3, 4].includes(criteria.key)
              "
            >
              <InputRequiredText
                v-model="criteria.text2"
                PropName="Key"
                :placeholder="'Enter value'"
                id="text1"
              ></InputRequiredText>
            </div>
            <PrimeButton
              label="Ok"
              class="save-btn1 ml-1"
              icon="pi pi-check"
              @click="okButtonClickedHandler(criteria)"
            ></PrimeButton>
            <PrimeButton
              v-if="
                criteria.key !== null &&
                [0, 1, 2, 3, 4, 5, 6, 7, 8].includes(criteria.key)
              "
              label="Cancel"
              class="cancel-btnadd ml-1"
              @click="cancelButton(criteria)"
            ></PrimeButton>
            <PrimeButton
              v-if="
                vmodel1.triggerDropdown.length > 1 &&
                criteria.key !== null &&
                [0, 1, 2, 3, 4, 5, 6, 7, 8].includes(criteria.key)
              "
              class="delete-btn ml-1"
              @click="deleteButton(index)"
            >
              <i class="pi pi-trash"></i>
            </PrimeButton>
          </div>
          <div
            v-else
            class="col-12 lg:col-11 area-1 mt-3 delete-button-container"
          >
            <p
              v-if="
                criteria.key == 0 ||
                criteria.key == 1 ||
                criteria.key == 2 ||
                criteria.key == 3 ||
                criteria.key == 4 ||
                criteria.key == 5 ||
                criteria.key == 6 ||
                criteria.key == 7 ||
                criteria.key == 8
              "
            >
              First Dropdown Value:
              <b>{{ getExternalFieldDescription(criteria) }}</b
              >, Second Dropdown Value:
              <b>{{ getInternalFieldDescription(criteria) }}</b>
              <b>Text 1:</b>
              <b>{{ criteria.text1 }}</b>
              <!-- <b>Text 2:</b>
              <b>{{ criteria.text2 }}</b> -->
            </p>
            <PrimeButton
              v-if="
                vmodel1.triggerDropdown.length > 1 &&
                (criteria.key == 0 ||
                  criteria.key == 1 ||
                  criteria.key == 2 ||
                  criteria.key == 3 ||
                  criteria.key == 4 ||
                  criteria.key == 5 ||
                  criteria.key == 6 ||
                  criteria.key == 7 ||
                  criteria.key == 8)
              "
              class="delete-btn ml-1"
              @click="deleteButton(index)"
            >
              <i class="pi pi-trash"></i>
            </PrimeButton>
          </div>
        </div>

        <div v-if="!openAddGroup">
          <PrimeButton
            label="Add criteria"
            icon="pi pi-plus"
            class="addCriteria"
            @click="addCriteria()"
          ></PrimeButton>
        </div>
     <div v-if="openminized == true">
          <div class="grid mt-2">
            <div class="col-12 lg:col-10"></div>
            <div class="col-12 lg:col-1 ml-1">
              <PrimeButton label="Include" class="include-btn" @click="exixtingUserPopup()"></PrimeButton>
            </div>
          </div>
          <div class="grid center">
            <div class="col-12 lg:col-6 ml-4">
              <span>{{ staticData.target.maxwidget }}</span>
            </div>
            <div class="col-12 lg:col-5">
              <DropDownRequire
                v-model="selectedTimeDelay"
                :options="timedelay"
                PropName="Site"
                id="SiteId"
                placeholder="Time Delay"
                optionLabel="text"
                optionValue="value"
                class="dropdown-1"
                editable
              ></DropDownRequire>
            </div>
          </div>
          <div class="grid">
            <div class="col-12 lg:col-6 ml-4"></div>

            <div class="col-12 lg:col-5">
              <div style="display: flex">
                <input type="text" v-model="value" class="input-text-hrs" />
                <button class="hrs-btn">sec</button>
                <div>
                  <button @click="increaseValue" class="up-btn">
                    <i class="pi pi-chevron-up ar-color"></i>
                  </button>
                  <button @click="decreaseValue" class="down-btn">
                    <i class="pi pi-chevron-down ar-color"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="col-12 lg:col-4"></div>
          </div>
        </div>
        <div class="border-line mt-3"></div>

        <div
          :class="
            !isDisabled
              ? 'header-edit-mode text-right button-container'
              : 'head-mode text-right button-container'
          "
        >
          <PrimeButton
            id="cancelbtn"
            type="button"
            name="Cancel"
            @click="cancelBtn()"
            value="cancel"
            label="Cancel"
            class="cancel-btnadd"
          />
          <PrimeButton
            label="Save"
            class="save-btn1 ml-2 mr-2"
            icon="save-icon"
            @click="saveTargeting()"
          ></PrimeButton>
        </div>
      </div>
    </div>

    <div v-if="(isTarget && isDisabled) || (isSave && !isTarget)">
      <div class="grid line-text">
        <div class="col-12 lg:col-3">
          <label for="withUrl" class="control-label1">
            {{ staticData.target.showpageurl }}
          </label>
        </div>
        <div class="col-12 lg:col-7">
          <label for="web1" class="control-label">
            {{ staticData.target.showpageurldata }}
          </label>
        </div>
      </div>
      <div class="grid line-text">
        <div class="col-12 lg:col-3">
          <label for="withoutUrl" class="control-label1">
            {{ staticData.target.showpageurlnotcontaining }}
          </label>
        </div>
        <div class="col-12 lg:col-7">
          <label for="web2" class="control-label">
            {{ staticData.target.showpageurlnotcontainingdata }}
          </label>
        </div>
      </div>
      <div class="grid line-text-2">
        <div class="col-12 lg:col-3">
          <label for="speUrl" class="control-label1">
            {{ staticData.target.showpaewithspecialurl }}
          </label>
        </div>
        <div class="col-12 lg:col-7">
          <label for="web3" class="control-label">
            {{ staticData.target.showpaewithspecialurldata }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import staticData from "@/staticdata/static.json";


export default {
  components: {},
  props: {
    openminized: {
      type: Boolean,
      default: false,
    },
    dealId: {
      type: String,
      default: null,
    },
    isCancelClick: {
      type: Boolean,
      default: false,
    },
    tabId: {
      type: Number,
      default: 0,
    },

    lmodel: {
      type: Object,
      default: null,
    },
    dmodel: {
      type: Object,
      default: null,
    },
    vmodel: {
      type: Object,
      default: null,
    },
    valmodel: {
      type: Object,
      default: null,
    },
    dealStatus: {
      type: Number,
      default: null,
    },
    isRedealText: {
      type: Boolean,
      default: false,
    },
    resultData: {
      type: Object,
      default: null,
    },
    customerCampaignDealyDaysError: {
      type: String,
      default: null,
    },
    enableAmbassadorMailsAmb: {
      type: Boolean,
      default: false,
    },
    modelstate: {
      type: Object,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isTarget: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    vmodel1: {
      get() {
        return this.vmodel;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    addButtonsEnabled() {
      return this.triggerDropdown.every((criteria) => criteria.key !== null);
    },
    addGroupButtonsEnabled() {
      return this.criteriaGroupList.every((criteria) => criteria.key !== null);
    },
  },

  data() {
    return {
      key: null,
      selectedTimeDelay: null,
      staticData: staticData,
      loader: false,
      openAddGroup: false,
      isEnable: false,
      isEditMode: false,
      isSave: false,
      value: 0,
      lineColor: "#5da386",
      selectedButton: "#5da386",

      criteriaGroupList: [
        {
          key: null,
          text1: 0,
          inputNumberEnabled: false,
        },
      ],
      timedelay: [
        { text: "Automatically maximize after delay", value: 0 },
        { text: "Automatically maximize after number page visit", value: 1 },
        { text: "Automatically maximize after idle time", value: 3 },
      ],
      temp: false,
      selectedCountry: null,
      selectedOption: null,
      externalDropdownVal: [],
      internalDropdownVal: [],
      excatMatchDropdownVal: [],
      userDropDownVal: [],
      triggerDropdown: [],
      providedDropDownVal: [],
    };
  },
  mounted() {
    if (this.vmodel.triggerDropdown.length < 1) {
      this.vmodel1.triggerDropdown.push({
        key: "",
        value: "",
        text1: "",
        text2: "",
      });
    }
    this.initializeCriteria();
    if (this.resultData !==[]) {
      this.externalDropdownVal = this.resultData.data.keyfieldDropDown;
      this.internalDropdownVal = this.resultData.data.containsDropDown;
      this.excatMatchDropdownVal = this.resultData.data.exactDropDown;
      this.userDropDownVal = this.resultData.data.userDropDown;
      this.providedDropDownVal = this.resultData.data.provideDropDown;
    }
  },

  // created() {},

  emits: ["call", "cancel"],
  methods: {
    initializeCriteria() {
      this.vmodel1.triggerDropdown.forEach((criteria) => {
        if (
          criteria.key !== null &&
          criteria.value !== null &&
          criteria.text1 !== ""
        ) {
          criteria.showMessage = true;
        }
      });
    },
    cancelBtn() {
      this.$emit("cancel");
    },
   
    getExternalFieldDescription(criteria) {
      if (criteria) {
        const selectedOption = this.externalDropdownVal.find(
          (option) => option.value == criteria.key
        );
        return selectedOption ? selectedOption.description : " ";
      }
    },
    getInternalFieldDescription(criteria) {
      if (criteria) {
        const selectedOption = this.internalDropdownVal.find(
          (option) => option.value == criteria.value
        );

        return selectedOption ? selectedOption.description : "";
      }
    },

    saveTargeting() {
      this.isSave = true;
      this.$emit("call");
    },
    EditData() {
      this.isEditMode = true;
    },

    cancelButton(criteria) {
      criteria.key = null;
      criteria.value = null;
      criteria.text1 = null;
    },
    enableSelectOption() {
      this.key = null;
      this.value = null;
      this.text1 = null;
    },
    okButtonClickedHandler(criteria) {
      if (criteria.key !== null) {
        criteria.showMessage = true;
        // Optionally push the criteria into the array if not already part of the array
        const index = this.vmodel1.triggerDropdown.findIndex(
          (item) => item === criteria
        );
        if (index === -1) {
          this.vmodel1.triggerDropdown.push(criteria);
        }
      }
    },

    clearAllCriteria() {
      this.openAddGroup = false;
      this.vmodel1.triggerDropdown = [
        {
          key: "",
          value: "",
          text1: "",
          text2: "",
        },
      ];

      this.temp = true;
      this.updateButtonStatus();
    },

    //for input-num in criteria

    addCriteria() {
      this.vmodel1.triggerDropdown.push({
        key: "",
        value: "",
        text1: "",
        text2: "",
        showMessage: false,
      });
    },
    deleteButton(index) {
      this.vmodel1.triggerDropdown.splice(index, 1);
    },

    updateButtonStatus() {
      this.addButtonsEnabled = this.triggerDropdown.length <= 1 && this.temp;
      this.addGroupButtonsEnabled =
        this.triggerDropdown.length <= 1 && this.temp;
    },

    deleteGroupButton(index) {
      this.criteriaGroupList.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.header-text {
  display: flex;
  align-items: center;
  height: auto;
  padding: 26px 40px 26px 40px;
  border-radius: 4px 4px 0px 0px;
}

h5 {
  font-size: 18px;
  font-family: "Voyado Text";
  margin-bottom: 0.5rem;
  font-weight: bold;
  line-height: 1.2;
  margin-top: 0;
  margin-bottom: 0.5rem;
}
.header-text h5 {
  margin: 0;
}
.header-text span {
  display: block;
  margin-top: 5px;
}

.icon-container {
  padding: 0px 20px 0px 0px;
  font-size: 1.5rem;
}

.text-area3 {
  height: 187px;
  // margin-top: 20px;
  align-items: center;
  padding: 20px 32px 20px 45px !important;
}

.text-area4 {
  height: 140px;
  display: flex;
  // align-items: center;
  padding: 0px 10px 0px 45px !important;
}

.edit-btn {
  background-color: #fff;
  border: 2px solid #e0e9e8;
  font-weight: 500;
  color: #2d6e6d;
  height: 40px;
  display: block;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.edit-btn:hover {
  background-color: #2d6e6d !important;
  border-color: #2d6e6d !important;
  color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: none;
}
.all-btn {
  background-color: #f0f0ef;
  border: none;
  border-radius: 0px;
  color: #909090;
  line-height: 15.6px;
  font-weight: 500;
  height: 24px;
  padding: 4px 7px 4px 7px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.all-btn:hover {
  background-color: #5da386 !important;
  border-color: #5da386 !important;
  color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: none;
}
.any-btn {
  background-color: #f0f0ef;
  border: none;
  border-left: 1px solid #909090;
  border-right: 1px solid #909090;
  border-radius: 0px;
  color: #909090;
  line-height: 15.6px;
  font-weight: 500;
  height: 24px;
  padding: 4px 7px 4px 7px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.any-btn:hover {
  background-color: #00c2c8 !important;
  border-color: #00c2c8 !important;
  color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: none;
}

.none-btn {
  background-color: #f0f0ef;
  border: none;
  border-radius: 0px;
  color: #909090;
  line-height: 15.6px;
  font-weight: 500;
  height: 24px;
  padding: 4px 7px 4px 7px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.none-btn:hover {
  background-color: #e85b46 !important;
  border-color: #e85b46 !important;
  color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: none;
}
.active-btn {
  color: #fff;
}

.header-container {
  height: 120px;
  padding: 26px 40px 26px 40px;
  gap: 0px;
  border-radius: 4px 4px 0px 0px;
  opacity: 0px;
}
:deep(.card-header) {
  height: 53px;
  border-color: #eff2f7;
  background-color: #f8f8f7 !important;
  font-size: 16px;
  font-weight: 500 !important;
  padding: 0.75rem 1.25rem;
  border-bottom: none;
}

input:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}
.p-inputtext:enabled:focus {
  outline: 0 none !important;
  outline-offset: 0 !important;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}

:deep(.p-chips:not(.p-disabled).p-focus .p-chips-multiple-container) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}
.p-chips .p-chips-multiple-container .p-chips-input-token input {
  font-size: 1rem;
  color: #212529;
  padding: 0;
  margin: 0;
  width: 370px;
}
:deep(.p-chips .p-chips-multiple-container .p-chips-input-token input) {
  padding: 20px;
  margin: 0;
  padding-top: 1px;
  padding-left: inherit;
}
.area-1 {
  height: 50px;
  margin-left: 65px;
  // margin-top: -30px;
  padding: 5px 5px 5px 5px;
  background: #efefef;
  display: flex;
}
.area-2 {
  padding: 5px 10px 5px 10px;
  margin-left: 15px;
  margin-top: 20px;
  background: #efefef;
  display: flex;
}
.dropdown {
  height: 40px;
  width: 180px;
  line-height: 1.5;
  font-size: 14px !important;
  border: 1px #c0c0bc;
  border-radius: 0.25rem;
  background-color: #fff !important;
  text-decoration: none;
  box-shadow: none;
  background: none;
  justify-content: space-between;
  margin-right: 10px;
  -webkit-box-shadow: none;
  outline: none;
}
.dropdown-1 {
  height: 40px;
  // width: 403px;
  line-height: 1.5;
  font-size: 14px !important;
  border: 1px #c0c0bc;
  border-radius: 0.25rem;
  background-color: #fff !important;
  text-decoration: none;
  box-shadow: none;
  background: none;
  justify-content: space-between;
  // margin-right: 10px;
  -webkit-box-shadow: none;
  outline: none;
}

.include-btn {
  height: 40px;
  width: auto;
  border-radius: 4px;
  border-color: #e0e9e8;
  background-color: #fff;
  color: #2d6e6d;
  font-weight: 500;
  line-height: 12.8px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.include-btn:hover {
  border-color: #2d6e6d !important;
  background-color: #2d6e6d !important;
  color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: none;
}

.delete-btn {
  border: none !important;
  background: none !important;
  color: #2d6e6d !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.delete-btn:hover {
  border-color: none !important;
  background-color: #e41300 !important;
  color: #0d1f1e !important;
  -webkit-box-shadow: none !important;
  box-shadow: none;
  outline: none;
}
.button-container {
  // padding: 10px 30px 20px 30px;
  padding: 26px 40px 26px 40px;
}
.line-text {
  align-items: center;
  padding: 0px 32px 0px 32px !important;
}

.line-text-2 {
  align-items: center;
  padding: 0px 32px 15px 32px;
}
.border-line {
  border-top: 1px solid #e5e5e5;
}
.criteria-container {
  position: relative;
}

.vertical-line {
  position: absolute;
  left: 45px;
  margin-top: 8px;
  margin-bottom: 0px;
  width: 1px;
  border: 2px solid;
  height: 35px;
  border-color: #5da386;
}
.vertical-line-full {
  position: absolute;
  left: 45px;
  margin-top: 8px;
  margin-bottom: 0px;
  width: 1px;
  border: 2px solid;
  height: 90%;
  min-height: 35px;
  border-color: #5da386;
}

.horizontal-line {
  position: absolute;
  left: 46px;
  top: 40px;
  width: 20px;
  height: 3px !important;
  background-color: #5da386;
}

.edit-btn[disabled] {
  background-color: #efefef;
  color: black;
  font-weight: 400;
  cursor: not-allowed !important;
  border-color: #efefef;
}
.control-label1 {
  font-size: 1rem;
  padding-bottom: 3px;
  display: block !important;
  margin-bottom: 0px;
  padding-top: 7px;
  font-weight: bold;
  position: relative;
  vertical-align: top;
}
.center {
  align-items: center;
}

.input-num {
  position: relative;
  width: 100%;
  display: flex;
}
.input-num input {
  flex: 1;
}

.input-num-1 {
  position: relative;
  width: 29% !important;
  display: flex;
  margin-right: 30px;
}
.input-num-1 input {
  flex: 1;
}
:deep(
    .p-inputnumber-buttons-stacked
      .p-inputnumber-button-group
      .p-button.p-inputnumber-button
  ) {
  background-color: #ffffff !important;
  color: #797971 !important;
  border-color: #c0c0bc !important;
}

//input-hrs-updown
.hrs-btn {
  border: none;
  height: 40px !important;
  background-color: #fff;
  border-top: 1px solid #c0c0bc;
  border-bottom: 1px solid #c0c0bc;
  color: #797971;
  cursor: text;
}
.input-text-hrs {
  height: 40px;
  width: 395px;
  border-radius: 0 !important;
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
  padding: 10px 10px 9px 10px;
  border-right: transparent;
  border-top: 1px solid #c0c0bc;
  border-bottom: 1px solid #c0c0bc;
  border-left: 1px solid #c0c0bc;
  font-family: "Voyado Text" !important;
}

.input-text {
  height: 40px;
  width: 217px;
  border-radius: 0 !important;
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
  padding: 10px 10px 9px 10px;
  border-right: transparent;
  border-top: 1px solid #c0c0bc;
  border-bottom: 1px solid #c0c0bc;
  border-left: 1px solid #c0c0bc;
  font-family: "Voyado Text" !important;
}

.down-btn {
  border: 1px solid #c0c0bc;
  background-color: #fff;
  height: 20px;
  width: 27px;
  display: grid;
  border-bottom-right-radius: 4px;
}

.up-btn {
  border: 1px solid #c0c0bc;
  background-color: #fff;
  height: 20px;
  width: 27px;
  display: grid;
  border-top-right-radius: 4px;
}
.ar-color {
  color: #797971 !important;
}
:deep(.p-inputnumber-buttons-stacked .p-inputnumber-button-group) {
  display: flex;
  flex-direction: column;
  height: 38px !important;
}

.addCriteria {
  border-radius: 4px;
  background: #f0f0ef;
  border: 2px solid #f0f0ef !important;
  font-family: Voyado Text;
  font-size: 14.22px;
  font-weight: 500;
  line-height: 12.8px;
  text-align: center;
  color: #c0c0bc;
  margin-left: 55px;
  margin-top: 10px;
  webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.clearAll {
  border-radius: 4px;
  background: #f0f0ef;
  border: 2px solid #f0f0ef !important;
  font-family: Voyado Text;
  font-size: 14.22px;
  font-weight: 500;
  line-height: 12.8px;
  text-align: center;
  color: #c0c0bc;
  // margin-left: 55px;
  margin-top: 10px;
}

.addCriteria:hover {
  background-color: #f0f0ef !important;
  border-color: #f0f0ef !important;
  color: #000 !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.clearCriteria {
  border-radius: 4px;
  background: #f0f0ef;
  border: 2px solid #f0f0ef !important;
  font-family: Voyado Text;
  font-size: 14.22px;
  font-weight: 500;
  line-height: 12.8px;
  text-align: center;
  color: #c0c0bc;
  // margin-left: 309px;
  margin-top: 10px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.clearCriteria:hover {
  background-color: #f0f0ef !important;
  border-color: #f0f0ef !important;
  color: #000 !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  outline: none !important;
}

:deep(.p-inputnumber-buttons-stacked .p-inputnumber-input) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  height: 40px;
}
:deep(.p-inputnumber-buttons-stacked .p-inputnumber-button-group) {
  height: 40px !important;
}

.delete-button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.disabled {
  border-radius: 4px;
  background: #f0f0ef;
  border: 2px solid #f0f0ef !important;
  font-family: Voyado Text;
  font-size: 14.22px;
  font-weight: 500;
  line-height: 12.8px;
  text-align: center;
  color: #909090;
  margin-left: 55px;
  margin-top: 10px;
}
.header-edit-mode {
  background-color: #f8f8f7 !important;
}
.head-mode {
  background-color: #fff !important;
}

.addGroupContainer {
  display: flex;
  flex-direction: column;
  align-items: center; /* Center items horizontally */
}

.addGroup {
  --line-offset: calc((100% - var(--group-height)) / 2);
  width: 850px;
  border: 1px solid #e2e2e2;
  position: relative;
  margin-left: 57px;
}

.delete-group {
  float: right;
  height: 30px;
  width: auto;
  border-radius: 4px;
  border-color: #e0e9e8;
  background-color: #fff;
  color: #2d6e6d;
  font-weight: 500;
  // line-height: 12.8px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  margin-left: 350px;
}

.delete-group:hover {
  border-color: #2d6e6d !important;
  background-color: #2d6e6d !important;
  color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: none;
}
.line-group {
  margin-left: 1px;
}

.area-2 {
  height: 50px;
  width: 800px;
  margin-left: 40px;
  padding: 5px;
  margin-top: 20px;
  background: #efefef;
  display: flex;
}

.vertical-line1 {
  position: absolute;
  left: 21px;
  margin-top: 2px;
  margin-bottom: 0px;
  width: 1px;
  border: 2px solid;
  height: 90%;
  min-height: 40px;
  border-color: #5da386; /* Default color */
}

.horizontal-line1 {
  position: absolute;
  left: 22px;
  top: 40px;
  width: 20px;
  height: 3px !important;
  background-color: #5da386;
}

.input-text-grp {
  height: 40px;
  width: 180px;
  border-radius: 0 !important;
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
  padding: 10px 10px 9px 10px;
  border-right: transparent;
  border-top: 1px solid #c0c0bc;
  border-bottom: 1px solid #c0c0bc;
  border-left: 1px solid #c0c0bc;
  font-family: "Voyado Text" !important;
}

.horizontal-groupline {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(-98%);
  width: 20px;
  height: 3px;
}

.vertical-groupline {
  position: absolute;
  left: 37px;
  width: 1px;
  border: 2px solid;
  min-height: 35px;
  height: 30%;
  top: 45%;
  transform: translateY(-70%);
  border-color: #5da386;
}
:deep(.heading-text) {
  height: 19px;
  font-family: "Voyado Text";
  font-size: 16px;
  font-weight: 600;
  line-height: 19.2px;
  text-align: left;
  color: #21211f;
}

.container-text {
  font-family: "Voyado Text";
  font-size: 14.22px;
  font-weight: 400;
  line-height: 17.07px;
  text-align: left;
  color: #21211f;
}

.addCriteria.enabled {
  color: #000 !important;
}
.addCriteria.disabled {
  color: #c0c0bc !important;
}
.clearCriteria.enabled {
  color: #000 !important;
}
.clearCriteria.disabled {
  color: #c0c0bc !important;
}

.header-edit-mode {
  background-color: #f8f8f7 !important;
}
.head-mode {
  background-color: #fff !important;
}

:deep(.p-inputtext) {
  font-family: "Voyado Text";
  // border: 1px solid #c0c0bc;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
